<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent1"><a id="ch00_fm05_dedi"></a><a id="page_ix"></a><em>For Katherina,</em><br/><em>the sound and touch of my life</em><a id="page_x"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm05_dedi.vue?382eeab1